import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'nb-auth-block',
    templateUrl: './auth-block.component.html',
    styleUrls: ['./auth-block.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AuthBlockComponent {

}
